import { all, put, take, takeEvery } from 'redux-saga/effects';
import { toSuccess } from 'react-async-client';
import { path } from 'ramda';

import { request } from 'constants/routes';
import { sidebarOpen } from 'actions/sidebarActions';
import { ADD_REQUEST, LOCATION_CHANGE } from 'constants/actionTypes';
import { REQUEST_SIDEBAR } from 'constants/sidebarTypes';
import { history } from 'store/browserHistory';

export default function* addRequest() {
    yield all([
        takeEvery(toSuccess(ADD_REQUEST), function* doRedirect(action) {
            const title = action.requestAction.payload.position;
            const id = path(['objkey'], action.payload);

            yield history.push(request.stringify({ status: 'inwork' }));
            yield take(LOCATION_CHANGE);

            if (id) {
                yield put(sidebarOpen({
                    componentName: REQUEST_SIDEBAR,
                    params: { title },
                    id,
                }));
            }
        })
    ]);
}
